/* eslint-disable camelcase */
import * as React from 'react';
import LocationSelect from '../../../page/components/selects/LocationSelect';
import { addToWaitlist } from '../../../services/api';
import { isDifferentTimezones, isScheduled } from '../../../utilities/helperUtility';
import Translation from '../../../utilities/localizationUtility';
import Alert from '../../Alert';
import QuantityComponent from '../QuantityComponent';
import {
  StyledButton,
  StyledDescription,
  StyledForm,
  StyledInput,
  StyledLabel,
  StyledModal,
  StyledTitle,
} from './Waitlist.style';

function buildError(errors) {
  let errorsArr = [];
  Object.keys(errors).forEach((key) => {
    errorsArr = [...errorsArr, ...errors[key]];
  });
  return errorsArr;
}

export default class Waitlist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      name: '',
      quantity: 1,
      loading: false,
      isLocationPreselected: false,
    };

    this.handleGetCloseFnModal = this.handleGetCloseFnModal.bind(this);
    this.handleGetOpenFnModal = this.handleGetOpenFnModal.bind(this);
    this.handleInputEmailChange = this.handleInputEmailChange.bind(this);
    this.handleInputNameChange = this.handleInputNameChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setAlertRef = this.setAlertRef.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    const { getCloseFn, getOpenFn } = this.props;
    getOpenFn(this.open);

    if (getCloseFn) {
      getCloseFn(this.close);
    }
  }

  getCapacity() {
    const { product } = this.props;
    if (product.capacity.type === 1) {
      return this.variantBasedCapacity();
    }

    return product.capacity.quantity;
  }

  handleGetCloseFnModal(closeFn) {
    this.closeModal = closeFn;
  }

  handleGetOpenFnModal(openFn) {
    this.openModal = openFn;
  }

  handleAfterOpen = () => {
    const { selectedLocation, onAfterOpen } = this.props;

    if (selectedLocation?.id && !this.state.isLocationPreselected) {
      this.setState({ isLocationPreselected: true });
    }

    onAfterOpen?.();
  };

  handleAfterClose = () => {
    const { onAfterClose } = this.props;

    this.setState({ isLocationPreselected: false });

    onAfterClose?.();
  };

  handleInputEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handleInputPhoneChange = (event) => {
    this.setState({ phone: event.target.value });
  };

  handleInputNameChange(event) {
    this.setState({ name: event.target.value });
  }

  handleQuantityChange(newQuantity) {
    const capacity = this.getCapacity();

    const quantity = newQuantity > capacity ? capacity : newQuantity;

    this.setState({ quantity });
  }

  onSubmit() {
    const {
      finish, onAddItem, product, selected, selectedLocation, variantSelected,
    } = this.props;
    const { email, phone, name, quantity } = this.state;
    const params = {
      email,
      phone,
      external_variant_id: variantSelected,
      location_id: selectedLocation?.id,
      name,
      quantity,
      starts_at: selected,
    };

    if (!product) {
      return;
    }

    if (finish) {
      params.finishes_at = finish;
    }

    this.setState({ loading: true });

    addToWaitlist(product.external_id, params)
      .then((response) => {
        this.setState({
          loading: false, email: '', name: '', phone: '', quantity: 1,
        });
        onAddItem(response.data.waitlist_item);
        this.closeModal();
      })
      .catch((error) => {
        this.setState({ loading: false });
        const { response } = error;
        if (response && response.data && response.data.errors) {
          this.alert.show('red', buildError(response.data.errors));
        } else {
          this.alert.show('red', ['SOMETHING WENT WRONG. PLEASE CONTACT OUR SUPPORT TEAM.']);
        }
      });
  }

  open() {
    this.setState({
      loading: false, email: '', name: '', quantity: 1,
    });
    this.openModal();
  }

  close() {
    this.setState({
      loading: false, email: '', name: '', quantity: 1,
    });
    this.closeModal();
  }

  setAlertRef(ref) {
    const { alert } = this.props;
    this.alert = alert || ref;
  }

  variantBasedCapacity() {
    const { isActivity, product, variantSelected } = this.props;
    if (isActivity) {
      return product.variants.reduce((sum, v) => sum + v.capacity, 0);
    }

    const variant = product.variants.find((v) => v.external_id === variantSelected);
    return variant?.capacity || product.capacity.quantity;
  }

  renderLocationDropdown = (isDisabled) => {
    const { locations, product: { profile } } = this.props;
    const t = new Translation(this.props);
    let blankOption = null;

    if (!isScheduled(profile) || !isDifferentTimezones(locations)) {
      blankOption = {
        label: t.key('locationDropdownPrompt') || 'Choose any',
        value: '',
      };
    }

    return (
      <LocationSelect
        className="mt10"
        errorMessage={t.key('missingLocationMessage')}
        label={t.key('locationPrompt')}
        blankOption={blankOption}
        isDisableClearable
        isDisabled={isDisabled}
      />
    );
  };

  render() {
    const { style, selectedLocation, displayPhoneNumberField, displayLocationField } = this.props;
    const {
      email,
      phone,
      name,
      quantity,
      loading,
    } = this.state;

    const isLocationPreselected = this.props.isLocationPreselected || this.state.isLocationPreselected;

    const { body, button, title } = style;
    const t = new Translation(this.props);
    const disabled = !(!!email && !!name) || loading;
    let buttonStyle = button;
    const quantityLabel = t.key('columnQuantity') || t.key('quantityPrompt') || t.key('quantity');
    const selectedLocationLabel = t.key('selectedLocation') || 'Selected Location';
    const customerPhonePrompt = t.key('customerPhonePrompt') || 'Your phone, e.g., +1123456789';

    if (disabled) {
      buttonStyle = { ...buttonStyle, backgroundColor: style.inactive.backgroundColor };
    }

    return (
      <StyledModal
        title=""
        closeWord=""
        getOpenFn={this.handleGetOpenFnModal}
        getCloseFn={this.handleGetCloseFnModal}
        onAfterOpen={this.handleAfterOpen}
        onAfterClose={this.handleAfterClose}
        portalClassName="waitlist-modal-form"
      >
        <StyledForm className="pure-form">
          <Alert ref={this.setAlertRef} />

          <StyledTitle style={title}>
            {t.key('waitlistTitle')}
          </StyledTitle>

          {displayLocationField && (
            isLocationPreselected
              ? (
              <StyledDescription style={body}>
                <dt>
                  {selectedLocationLabel}
                </dt>
                <dd>
                  {selectedLocation?.name}
                </dd>
              </StyledDescription>
              )
              : this.renderLocationDropdown())}

          <StyledLabel style={body}>
            <StyledInput
              className="form-control"
              name="name"
              type="text"
              placeholder={t.key('customerNamePrompt')}
              value={name}
              onChange={this.handleInputNameChange}
            />
          </StyledLabel>

          <StyledLabel style={body}>
            <StyledInput
              className="form-control"
              name="email"
              type="text"
              placeholder={t.key('customerEmailPrompt')}
              value={email}
              onChange={this.handleInputEmailChange}
            />
          </StyledLabel>

          {displayPhoneNumberField ? (
            <StyledLabel style={body}>
              <StyledInput
                className="form-control"
                name="phone"
                type="text"
                placeholder={customerPhonePrompt}
                value={phone}
                onChange={this.handleInputPhoneChange}
              />
            </StyledLabel>
          ) : null}

          <StyledLabel>
            <QuantityComponent
              label={quantityLabel}
              maxQuantity={this.getCapacity()}
              minQuantity={1}
              onClickNextButton={() => this.handleQuantityChange(quantity + 1)}
              onClickPrevButton={() => this.handleQuantityChange(quantity - 1 || 1)}
              style={style}
              quantity={quantity}
            />
          </StyledLabel>

          <StyledButton
            type="submit"
            styled={buttonStyle}
            disabled={disabled}
            onClick={this.onSubmit}
            submit
          >
            {t.key('addToWaitlist')}
          </StyledButton>
        </StyledForm>
      </StyledModal>
    );
  }
}
